export default "__VITE_ASSET__C5eBwas4__"